import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=116d79b6&scoped=true&"
import script from "./Referrals.vue?vue&type=script&lang=js&"
export * from "./Referrals.vue?vue&type=script&lang=js&"
import style0 from "./Referrals.vue?vue&type=style&index=0&id=116d79b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d79b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
